module.exports = __webpack_public_path__ + "static/img/MQ@3x.8e659c10.jpg";